import React, { useRef } from 'react';
import { MessageSquare, Send, X } from 'lucide-react';
import MentionInput, { MentionText } from '../MentionInput';
import Avatar from './Avatar';

export default function CommentsSection({
  comments, commentDraft, setCommentDraft, submitComment, deleteComment,
  commentBusy, members, currentUser, onTypingStart, onTypingStop
}) {
  const typingTimeoutRef = useRef(null);

  const handleChange = (v) => {
    setCommentDraft(v);
    if (onTypingStart) onTypingStart();
    if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
    typingTimeoutRef.current = setTimeout(() => {
      if (onTypingStop) onTypingStop();
    }, 2000);
  };
  return (
    <div>
      <div className="tm-label" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <MessageSquare size={12} /> Comments
        {comments.length > 0 && <span style={{ background: 'var(--trello-list-bg)', padding: '1px 6px', borderRadius: 8, fontSize: 10 }}>{comments.length}</span>}
      </div>
      <div style={{ maxHeight: 260, overflowY: 'auto', background: 'var(--trello-card-bg)', borderRadius: 6, padding: 8 }} data-testid="comments-list">
        {comments.length === 0 && (
          <div style={{ fontSize: 13, color: 'var(--trello-text-muted)' }}>No comments yet. Be the first!</div>
        )}
        {comments.map((c) => (
          <div key={c.id} className="flex items-start gap-2" style={{ padding: '8px 2px', borderBottom: '1px solid #F4F5F7' }} data-testid={`comment-${c.id}`}>
            <Avatar user={c.user} size={26} />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 12 }}>
                <b>{c.user.full_name}</b>{' '}
                <span style={{ color: 'var(--trello-text-muted)' }}>{new Date(c.created_at).toLocaleString()}</span>
              </div>
              <div style={{ fontSize: 13, whiteSpace: 'pre-wrap', marginTop: 2 }}>
                <MentionText text={c.body} />
              </div>
            </div>
            {(c.user.id === currentUser.id || currentUser.role === 'leader') && (
              <button className="tm-btn-ghost" style={{ padding: 2 }} onClick={() => deleteComment(c.id)} data-testid={`comment-del-${c.id}`}>
                <X size={12} />
              </button>
            )}
          </div>
        ))}
      </div>
      <div className="mt-2" style={{ position: 'relative' }}>
        <MentionInput
          value={commentDraft}
          onChange={handleChange}
          members={members}
          placeholder="Add a comment. Type @ to mention…"
          testId="comment-input"
          minRows={2}
        />
        <div className="flex justify-end mt-2">
          <button className="tm-btn" onClick={submitComment} disabled={commentBusy || !commentDraft.trim()} data-testid="comment-submit">
            <Send size={12} style={{ display: 'inline', marginRight: 4, verticalAlign: -1 }} />
            {commentBusy ? 'Posting…' : 'Post comment'}
          </button>
        </div>
      </div>
    </div>
  );
}
